import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import { Link as RouterLink, useLocation, useNavigate } from 'react-router-dom';

import { BrandMark } from '../BrandMark';

import { topNavStyles as styles } from './TopNav.styles';

interface TopNavProps {
  /**
   * `early-access` (default) shows the "Get Early Access" CTA that opens the
   * connect form. `back` shows a "Back to search" link (used on the form).
   */
  variant?: 'early-access' | 'back';
}

/**
 * Top navigation bar.
 * Figma: node 142:40355 on landing frame 58:39161.
 */
export function TopNav({ variant = 'early-access' }: TopNavProps) {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Box component="header" sx={styles.root}>
      <Link component={RouterLink} to="/" sx={styles.brand} aria-label="530A Solutions home">
        {/* Figma's mobile mockups show the icon mark alone, not the full
            wordmark lockup, in the nav bar. */}
        <Box sx={{ display: { xs: 'flex', sm: 'none' } }}>
          <BrandMark variant="mark" height={32} />
        </Box>
        <Box sx={{ display: { xs: 'none', sm: 'flex' } }}>
          <BrandMark variant="full" height={36} />
        </Box>
      </Link>
      <Box sx={styles.actions}>
        {variant === 'back' ? (
          <Button
            variant="text"
            color="primary"
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={styles.backButton}
          >
            Back to search
          </Button>
        ) : (
          <Button
            variant="contained"
            color="primary"
            // Carry the current filters/selection (query string) into the form.
            onClick={() => navigate(`/connect${location.search}`)}
          >
            Get Early Access
          </Button>
        )}
      </Box>
    </Box>
  );
}
